/*
 * Copyright (c) 2024 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 17/1/2024
 */

import { Box, Button, Container, Paper, Toolbar, Typography } from "@mui/material"
import { useState } from "react";
import { useDispatch } from "react-redux"
import SearchBar from "../Components/Shared/SearchBar";
import BrDialog from "../Components/BR/BrDialog";
import BrList from "../Components/BR/BrList";
import { useGetAllBrsQuery } from "../Store/Services/BrService";
import { closeBrModal, openAddBrModal } from "../Store/Slices/brSlice";
import styles from "./Management.module.css";

const UserRoleManagement = () => {

    const dispatch = useDispatch();
    const [searchData , setSearchData] = useState([]);
    const {data,isSuccess,isLoading} = useGetAllBrsQuery();


    const handleClose = () => {
        dispatch(closeBrModal());
    }

    const roles = sessionStorage.getItem("roles");

    return (
        roles?.split(",").includes("PRIV_ES_DISPLAY_ROLES") ? (
        <Paper elevation={3} className={styles.pageContainer} style={{backgroundImage: `url(${process.env.REACT_APP_IMAGE_URL}E_SERVICE/thumbnail_Management.png)`}}>
            <Box>
                <Toolbar className={styles.subNavBar}>
                    <Typography className={styles.topic}> Roles Management </Typography>
                    {roles?.split(",").includes("PRIV_ES_ADD_ROLE") ?  (<Button variant="contained" color="primary" className={styles.buttonItem} onClick={() => dispatch(openAddBrModal())}>Add Role </Button>) : null}
                </Toolbar>
            </Box>
            <Container id={styles.container}>
                <SearchBar
                    data={isSuccess || isLoading ? data : []}
                    setSearchData={setSearchData}
                    text="Search Roles"
                    search="br"
                />
            </Container>

            <Container>
               {isSuccess && <BrList data={Array.isArray(searchData) && searchData.length > 0 ? searchData : data}/>}
            </Container>

            <BrDialog handleClose={handleClose} />
        </Paper>) : null
    ) 
}

export default UserRoleManagement